<template>
  <v-container fluid class="pa-0">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title overflow-auto> Jobs </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card>
      <FeathersServiceTable
        service="jobs"
        :params="jobParams"
        :headers="headers"
        :loading="jobLoadPending"
        :sort-by="['status', 'priority', 'created']"
        :sort-desc="[false, false, false]"
        must-sort
        multi-sort
        :auto-refresh="5"
        class="elevation-1"
      >
        <template #item.priority="{ item }">
          <v-text-field
            :value="item.priority"
            class="pa-1"
            type="number"
            min="0"
            solo
            single-line
            hide-details
            @change="updateJobPriority(item.id, $event)"
          ></v-text-field>
        </template>
        <template #item.case_id="{ item: { case_id } }">
          <FeathersVuexGet service="cases" :id="case_id">
            <template #default="{ item }">
              <router-link :to="gotoCase(item)">
                {{ item != null && item.name ? item.name : item }}
              </router-link>
            </template>
          </FeathersVuexGet>
        </template>
        <template #item.user_id="{ item }">
          <FeathersVuexGet service="users" :id="item.user_id">
            <template #default="{ item }">
              <template v-if="item != null && item.email.endsWith('@acelerex.com')">
                Acelerex Admin
              </template>
              <template v-else>
                {{ item ? item.email : item }}
              </template>
            </template>
          </FeathersVuexGet>
        </template>
        <template #item.created="{ item }">
          <span v-html="dateWithBreak(item.created)"></span>
        </template>
        <template #item.type="{ item }">
          {{ getJobTypeName(item) | snakeToHuman }}
        </template>
        <template #item.status="{ item }">
          <JobIndicator :status="item.status" :progress="item.progress" disabled-tooltip />
        </template>
        <template #item.actions="{ item }">
          <DialogConfirm
            title="Confirm"
            message="Are you sure you want to stop this job?"
            @confirm="removeJob(item.id)"
          >
            <template #activator="{ on: onDialog }">
              <v-tooltip top>
                <template #activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="{ ...onDialog, ...on }">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Remove Job</span>
              </v-tooltip>
            </template>
          </DialogConfirm>
        </template>
      </FeathersServiceTable>
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable no-param-reassign */
import { mapGetters, mapActions } from "vuex";
import { FeathersVuexGet } from "feathers-vuex";
import filters from "@/mixins/filters";

export default {
  name: "JobOverview",
  components: {
    JobIndicator: () => import("@/components/JobIndicator.vue"),
    FeathersServiceTable: () => import("@/components/FeathersServiceTable.vue"),
    DialogConfirm: () => import("@/components/DialogConfirm.vue"),
    FeathersVuexGet,
  },
  mixins: [filters],
  props: {},
  data() {
    return {
      tabModel: null,
      headers: [
        {
          text: "Priority",
          value: "priority",
          width: 100,
          sort: (a, b) => (a < b && a != null ? -1 : 1),
        },
        {
          text: "Started At",
          value: "created",
        },
        {
          text: "Started By",
          value: "user_id",
        },
        {
          text: "Case",
          value: "case_id",
        },
        {
          text: "Type",
          value: "type",
        },
        {
          text: "Status",
          value: "status",
        },
        {
          text: "Actions",
          value: "actions",
        },
      ],
      modules: [
        {
          name: "Alternative Analysis",
          value: "ALTERNATIVE_ANALYSIS",
          type: 1,
        },
        {
          name: "Production Cost",
          value: "PRODUCTION_COST",
          type: 2,
        },
        {
          name: "Stacked Services Emulator",
          value: "STACKED_SERVICES_EMULATOR",
          type: 7,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      jobLoadPending: "jobs/loadPending",
      getCase: "cases/get",
      getUser: "users/get",
    }),
    jobParams() {
      return {
        query: {
          status: { $in: ["NOT_STARTED", "IN_PROGRESS"] },
          $sort: {
            created: 1,
            priority: 1,
            status: 1,
          },
        },
      };
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    ...mapActions({
      removeJob: "jobs/remove",
      patchJob: "jobs/patch",
    }),
    getJobTypeName(item) {
      if (item == null) return null;
      if (item.type_name != null) return item.type_name;
      const t = this.modules.find((el) => el.type === item.type);
      if (t != null) return t.name;
      return null;
    },
    gotoCase(item) {
      if (item == null) return {};
      const { scenario_id: scenario, id } = item;
      return {
        name: "CaseInput",
        params: { scenario, id },
      };
    },
    updateJobPriority(jobId, priority) {
      if (priority === "") priority = null;
      return this.patchJob([jobId, { priority }]);
    },
    dateWithBreak(date) {
      const datestamp = new Date(date);
      const day = datestamp.toLocaleDateString();
      const time = datestamp.toLocaleTimeString();
      return `${day} <wbr>${time}`;
    },
  },
};
</script>

<style></style>
